class WebSocketService {
    constructor() {
        this.ws = null;
        this.reconnectInterval = null;
        this.mongoReconnectDelay = 5000; // 初始重連間隔 5 秒
    }

    connect(url, onDataUpdate) {
        this.ws = new WebSocket(url);

        this.ws.onopen = () => {
            // console.log('[WebSocketService] WebSocket connected to:', url);

            if (this.reconnectInterval) {
                clearTimeout(this.reconnectInterval);
                this.reconnectInterval = null;
            }

            this.resetReconnectDelay(); // **WebSocket 連線成功時，重置重連間隔**
        };

        this.ws.onmessage = (event) => {
            requestIdleCallback(() => {
                const data = JSON.parse(event.data);

                if (onDataUpdate) {
                    onDataUpdate(data);
                }
            });
        };

        this.ws.onerror = (error) => {
            // console.error('[WebSocketService] WebSocket error:', error);
        };

        this.ws.onclose = (event) => {
            // console.warn(`[WebSocketService] WebSocket closed: Code=${event.code}, Reason=${event.reason}`);

            this.reconnect(url, onDataUpdate);
        };
    }

    disconnect() {
        if (this.ws) {
            // console.log('[WebSocketService] Disconnecting WebSocket...');
            this.ws.close();
        } else {
            // console.warn('[WebSocketService] WebSocket is not initialized.');
        }
    }

    send(data) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(data);
        } else {
            // console.warn('[WebSocketService] WebSocket is not open, cannot send data. readyState=', this.ws ? this.ws.readyState : 'no ws');
        }
    }

    reconnect(url, onDataUpdate) {
        // console.log(`[WebSocketService] Attempting to reconnect in ${this.mongoReconnectDelay / 1000} seconds...`);

        this.reconnectInterval = setTimeout(() => {
            this.connect(url, onDataUpdate);
        }, this.mongoReconnectDelay);
    }

    resetReconnectDelay() {
        this.mongoReconnectDelay = 5000; // **WebSocket 連線成功後，重置回 5 秒**
        // console.log('[WebSocketService] Reconnect delay reset to 5 seconds.');
    }

}

export const websocketService = new WebSocketService();
